@if (isImpersonating) {
  <div class="impersonation-banner">
    <div class="banner-content">
      <lucide-icon name="arrow-left-right" class="banner-icon"></lucide-icon>
      <span class="banner-text">
        You are viewing as <strong>{{ targetUserName }}</strong>
      </span>
      <button
        class="exit-button"
        (click)="exitImpersonation()"
        [disabled]="isExiting">
        @if (isExiting) {
          <lucide-icon name="loader-circle" class="animate-spin"></lucide-icon>
        } @else {
          <lucide-icon name="log-out"></lucide-icon>
        }
        Exit
      </button>
    </div>
  </div>
}
